import http from "@/http-common"

interface SubscriptionItem {
  product_plan_code: string
  quantity: number
  shooting_date: string | null
  selected_options?: number[]
}

interface SaleSubscriptionRequest {
  establishment_id: number
  upsell_contract_id?: number | null
  items: SubscriptionItem[]
  billing_email?: string
  billing_name?: string
  billing_address_line1?: string
  billing_postal_code?: string
  billing_city?: string
  billing_country?: string
}

class SubscriptionDataService {
  /**
   * Récupérer toutes les souscriptions du compte avec leurs contrats et paiements
   * @returns Promise avec la liste des souscriptions
   */
  getSubscriptions(): Promise<any> {
    return http.get("/auth/subscriptions")
  }

  /**
   * Récupérer le récapitulatif d'une souscription (détail des offres, lignes, totaux).
   * Même structure que cart/calculate.
   * @param subscriptionId ID de la souscription
   * @returns Promise avec le récapitulatif
   */
  getSubscriptionRecap(subscriptionId: string | number): Promise<any> {
    return http.get(`/auth/subscriptions/${subscriptionId}/recap`)
  }

  /**
   * Créer une souscription côté SALE
   * @param data Les données de la souscription
   * @returns Promise avec la réponse de l'API
   */
  createSaleSubscription(data: SaleSubscriptionRequest): Promise<any> {
    return http.post("/checkout/sale-subscription", data)
  }

  /**
   * Récupérer l'URL du PDF d'une facture Stripe
   * @param paymentId L'ID du paiement
   * @returns Promise avec l'URL du PDF
   */
  getInvoicePdfUrl(paymentId: number): Promise<any> {
    return http.get(`/auth/subscriptions/payments/${paymentId}/invoice-pdf-url`)
  }

  /**
   * Télécharger le PDF d'une facture
   * @param paymentId L'ID du paiement
   * @returns Promise avec le blob du PDF
   */
  async downloadInvoicePdf(paymentId: number): Promise<Blob> {
    const response = await http.get(`/auth/subscriptions/payments/${paymentId}/download-invoice`, {
      responseType: "blob",
    })
    return response.data
  }

  /**
   * Réessayer un paiement échoué (fonds insuffisants)
   * @param paymentId L'ID du paiement
   * @returns Promise avec la réponse de l'API
   */
  retryPayment(paymentId: number): Promise<any> {
    return http.post(`/auth/subscriptions/payments/${paymentId}/retry`)
  }
}

export default new SubscriptionDataService()
